//apifetch
import axios from "axios";

//translate
import i18n from "../../translate/i18n";

//type
import { addDriverReqType } from "./type/AddDriverType";

//server path
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const UpdateCarApi = async (data: addDriverReqType, id?:number) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(`${baseURL}/cars/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": i18n.language,
        Authorization: `Bearer ${token}`,
        "X-HTTP-Method-Override": "PUT",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error(error.response?.data || error.message);
    throw error;
  }
};

